import { useEffect, useCallback } from 'react';
import useHttp from '../http/useHttp';
import SourceType from '../../Models/Locations/sourceType';

export default function useFetchSourceTypes() {
  const { getDataResponse, getData } = useHttp();

  const init = useCallback(async () => {
    await getData('lookup/getsourcetypes');
  }, []);

  let sourceTypes: SourceType[] = getDataResponse?.data ?? [];

  useEffect(() => {
    init();
  }, [init]);

  return { sourceTypes };
}
